import React from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';

const PlanDetailsModal = ({ isOpen, toggle, planDetails, showMscColumns = false, partnershipCommission }) => {
  if (!planDetails || planDetails.length === 0) {
    return null;
  }

  const resolvedShowMscColumns = showMscColumns || planDetails.some((plan) => (
    plan?.old_msc_percentage !== undefined || plan?.new_msc_percentage !== undefined
  ));

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} className="pb-2" style={{ borderBottom: '1px solid #e5e7eb' }}>
        <span style={{ fontWeight: 600, fontSize: '14px', color: '#374151', letterSpacing: '0.01em' }}>
          Affected Plans
          <span className="badge badge-primary" style={{ marginLeft: '8px', fontSize: '11px', verticalAlign: 'middle' }}>
            {planDetails.length}
          </span>
        </span>
      </ModalHeader>
      <ModalBody style={{ padding: '16px 20px 20px' }}>
        <div
          style={{
            border: '1px solid #e5e7eb',
            borderRadius: '6px',
            overflow: 'hidden',
            background: '#fff',
          }}
        >
          <Table className="table table-sm" style={{ marginBottom: 0, width: '100%', tableLayout: 'fixed' }}>
            <colgroup>
              <col style={{ width: resolvedShowMscColumns ? '42%' : '56%' }} />
              <col style={{ width: resolvedShowMscColumns ? '28%' : '44%' }} />
              {resolvedShowMscColumns && <col style={{ width: '15%' }} />}
              {resolvedShowMscColumns && <col style={{ width: '15%' }} />}
            </colgroup>
            <thead style={{ background: '#e7e4ff' }}>
              <tr>
                {/* <th style={{ padding: '10px 12px', fontWeight: 600, color: '#4c1d95', fontSize: '12px', border: 'none', borderBottom: '1px solid #c4b5fd', textAlign: 'left', whiteSpace: 'nowrap' }}>Plan ID</th> */}
                <th style={{ padding: '10px 12px', fontWeight: 600, color: '#4c1d95', fontSize: '12px', border: 'none', borderBottom: '1px solid #c4b5fd', textAlign: 'left' }}>Plan Title</th>
                <th style={{ padding: '10px 12px', fontWeight: 600, color: '#4c1d95', fontSize: '12px', border: 'none', borderBottom: '1px solid #c4b5fd', textAlign: 'left', whiteSpace: 'nowrap' }}>Company</th>
                {resolvedShowMscColumns && <th style={{ padding: '10px 12px', fontWeight: 600, color: '#4c1d95', fontSize: '12px', border: 'none', borderBottom: '1px solid #c4b5fd', textAlign: 'center', whiteSpace: 'nowrap' }}>Old MSC %</th>}
                {resolvedShowMscColumns && <th style={{ padding: '10px 12px', fontWeight: 600, color: '#4c1d95', fontSize: '12px', border: 'none', borderBottom: '1px solid #c4b5fd', textAlign: 'center', whiteSpace: 'nowrap' }}>New MSC %</th>}
              </tr>
            </thead>
            <tbody>
              {planDetails.map((plan, idx) => {
                const displayOldMsc = plan?.old_msc_percentage === 0 ? partnershipCommission : (plan?.old_msc_percentage ?? '-');
                const showPercentOld = displayOldMsc !== '-' && displayOldMsc !== undefined && displayOldMsc !== null;
                
                return (
                <tr
                  key={`${plan?.plan_id || 'plan'}-${idx}`}
                  style={{
                    background: idx % 2 === 0 ? '#ffffff' : '#faf9ff',
                    transition: 'background 0.15s',
                    verticalAlign: 'top',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = '#ede9fe')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = idx % 2 === 0 ? '#ffffff' : '#faf9ff')}
                >
                  {/* <td style={{ padding: '10px 12px', fontSize: '12px', border: 'none', borderBottom: '1px solid #f3f4f6', whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                    <span className="badge badge-primary" style={{ fontSize: '11px', fontWeight: 600 }}>
                      {plan.plan_id}
                    </span>
                  </td> */}
                  <td style={{ padding: '10px 12px', fontSize: '12px', fontWeight: 500, color: '#111827', border: 'none', borderBottom: '1px solid #f3f4f6', wordBreak: 'break-word', lineHeight: 1.35 }}>
                    {plan.plan_title || '-'}
                  </td>
                  <td style={{ padding: '10px 12px', fontSize: '12px', color: '#6b7280', border: 'none', borderBottom: '1px solid #f3f4f6', whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                    {plan.company_title || '-'}
                  </td>
                  {resolvedShowMscColumns && (
                    <td style={{ padding: '10px 12px', fontSize: '12px', color: '#6b7280', border: 'none', borderBottom: '1px solid #f3f4f6', textAlign: 'center', whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                      <span style={{ display: 'inline-block', minWidth: '42px' }}>
                        {displayOldMsc}{showPercentOld ? '%' : ''}
                      </span>
                    </td>
                  )}
                  {resolvedShowMscColumns && (
                    <td style={{ padding: '10px 12px', fontSize: '12px', color: '#6b7280', border: 'none', borderBottom: '1px solid #f3f4f6', textAlign: 'center', whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                      <span style={{ display: 'inline-block', minWidth: '42px' }}>
                        {plan?.new_msc_percentage ?? '-'}{plan?.new_msc_percentage !== undefined && plan?.new_msc_percentage !== null ? '%' : ''}
                      </span>
                    </td>
                  )}
                </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PlanDetailsModal;
